<div class="field row" *ngIf="date">
    <label class="field-label" for="{{idUnique}}" translate="recentRepairOrderLabel"></label>
    <span class="field-data qa-repair-order-date" id="{{idUnique}}"
          [ngClass]="{service: alertExists}">{{recentRepairOrder}}</span>
</div>
